import React, { type ReactNode } from 'react'
import { KibButtonNew } from '@chewy/kib-controls-react'
import classNames from 'classnames'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import styles from './AgentResponseButton.module.scss'

export interface AgentResponseButtonProps {
  children: ReactNode
  disabled?: boolean
  emphasis?: 'primary' | 'secondary' | 'tertiary'
  icon?: React.ReactNode
  onClick?: () => void
  theme?: 'action' | 'utility' | 'destructive' | 'transactional'
}

/**
 * Shared button for agent chat responses: suggested prompts and feedback reason choices.
 * Defaults to tertiary emphasis so buttons are visible against the agent bubble background.
 */
export const AgentResponseButton: React.FC<AgentResponseButtonProps> = ({
  children,
  disabled = false,
  emphasis = 'tertiary',
  icon,
  theme = 'utility',
  onClick,
}) => (
  <div
    className={classNames(styles.agentResponseButton, {
      [styles.agentResponseButtonUtility]: theme === 'utility',
    })}
  >
    <KibButtonNew
      disabled={disabled}
      emphasis={emphasis}
      icon={icon}
      iconPosition="start"
      size="small"
      theme={theme}
      onClick={onClick}
    >
      {children}
    </KibButtonNew>
  </div>
)

export default AgentResponseButton
